
<div class="v-flex">
    <v-icon size="22" color="primary" class="mr-1">{{ selected ? 'mdi-menu-down' : 'mdi-menu-right' }}</v-icon>
    <v-icon size="22" color="primary" class="mr-1">{{ selected ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
    <div class="customer-name " :class="selected ? 'mt-2' : ''">
        {{ customer.name }}
    </div>
    <v-spacer />
    <div v-if="selected" class="unit-count">
        {{ count }}
    </div>
    <div>
        <c-toolbar-button
            v-if="selected"
            icon="mdi-filter"
            size="22"
            color="primary"
            @click="onFilter"
        />
    </div>
</div>
